import React, { useEffect, useState, useCallback } from "react";

/* ══ SPOTLIGHT RING ══════════════════════════════════════
 *
 * Renders only the ring + backdrop around a target element
 * matched by data-onboarding-target="…". Pointer-events
 * stay on the target element (the ring is a non-interactive
 * visual) so the user can tap the real UI underneath.
 *
 * The coach-mark hint card is handled separately by the
 * wizard so sheet state and spotlight state can animate
 * independently.
 * ════════════════════════════════════════════════════════ */

export default function Spotlight({ targetAttr }) {
  const [rect, setRect] = useState(null);

  const measure = useCallback(() => {
    const el = document.querySelector(`[data-onboarding-target="${targetAttr}"]`);
    if (!el) return null;
    const r = el.getBoundingClientRect();
    return {
      top: r.top - 6,
      left: r.left - 6,
      width: r.width + 12,
      height: r.height + 12,
    };
  }, [targetAttr]);

  useEffect(() => {
    let tries = 0;
    const maxTries = 40;
    let raf;
    const tick = () => {
      const r = measure();
      if (r && r.width > 0 && r.height > 0) { setRect(r); return; }
      if (tries++ < maxTries) raf = requestAnimationFrame(tick);
    };
    tick();

    const onResize = () => { const r = measure(); if (r) setRect(r); };
    window.addEventListener("resize", onResize);
    window.addEventListener("scroll", onResize, true);
    return () => {
      if (raf) cancelAnimationFrame(raf);
      window.removeEventListener("resize", onResize);
      window.removeEventListener("scroll", onResize, true);
    };
  }, [measure]);

  if (!rect) return <div className="ob-sp-ring-empty" />;

  return (
    <div
      className="ob-sp-ring"
      style={{
        top: rect.top + "px",
        left: rect.left + "px",
        width: rect.width + "px",
        height: rect.height + "px",
      }}
    />
  );
}
